import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../../app/app.service';
import { OrdinalDateParse } from '../../adapters/ordinal-date-adapter';
import { LeavesStatusVM, LeavesTypesVM, NewLeaveInfo, SiteCodes, UsersVM } from '../../entities/global/model';
import { MY_FORMATS } from '../../search-form-analysisreporting/search-form-analysisreporting.component';
import { SafetyConfigService } from '../../services/safety-config.service';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { SafetyLeavesService } from '../../services/safety-leaves.service';
import { UpdateLeaveStatusComponent } from '../update-leave-status/update-leave-status.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-leave-administration',
  templateUrl: './leave-administration.component.html',
  styleUrls: ['./leave-administration.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})

export class LeaveAdministrationComponent implements OnInit {

  endDate: Date;
  startDate: Date;
  siteCodesList: SiteCodes[] = [];
  selectedState:number;
  selectedLeaveType:number;
  selectedLeavesStatus:number;
  selectedRequestedUser:number;
  leavesTypesList:LeavesTypesVM[]= [];
  leavesStatusList:LeavesStatusVM[]= [];
  LeaveRequestList:NewLeaveInfo[]=[];
  requestedUserList:UsersVM[]= [];
  constructor(private _appService: AppService,
    private _dialog: MatDialog,
    private _notify: NotificationsService,
    private _safetyConfigService: SafetyConfigService,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private _safetyLeaves :SafetyLeavesService) { }
    ord: OrdinalDateParse = new OrdinalDateParse();
  ngOnInit() {
    this._appService.setPageTitle('Leave Administration');
    this.loadSiteList();
    this.loadUserList();
    this.loadLeavesTypes();
    this.loadLeavesStatus();
    this.LoadAllTheLeaveRequests();
  }

  loadSiteList() {
    this._safetyConfigService.getAllSitesList().subscribe(sites => {
      this.siteCodesList = sites;

    });
  }

  loadLeavesTypes(){
    this._safetyLeaves.GETAllLeavesTypes().subscribe(res=>{
      this.leavesTypesList =res;
    })
  }
  
  loadLeavesStatus(){
    this._safetyLeaves.GetAllLeavesStatus().subscribe(res=>{
      this.leavesStatusList =res;
    })
  }

  ResetFields(){
    this.endDate = null;
    this.startDate= null;
    this.selectedState=null;
    this.selectedLeaveType=null;
    this.selectedRequestedUser=null;
    this.selectedLeavesStatus=null;
  }
  
  loadUserList() {
    this._safetyGeneraldashboardService.GetUsersForSafetyApp().subscribe(res => {
      console.log(res);
      this.requestedUserList = res    
    })
  }

  LoadAllTheLeaveRequests(){
const params = new NewLeaveInfo();
params.LeaveTypeId=this.selectedLeaveType;
params.StatusId=this.selectedLeavesStatus;
params.StateId=this.selectedState;
params.RequestedUserId=this.selectedRequestedUser;
let _StartDate =this.startDate? this.ord.formatDateOrdinal((this.startDate.toString())
.split(' ')
.slice(1)
.join(' '), false):this.startDate;
let _EndDate = this.endDate?this.ord.formatDateOrdinal((this.endDate.toString())
.split(' ')
.slice(1)
.join(' '), false):this.endDate;

params.LeaveFrom_ = _StartDate;
params.LeaveTo_ = _EndDate;

    this._safetyLeaves.GETAllLeaves(params).subscribe(res=>{
      this.LeaveRequestList =res;
    })
  }

  SearchLeaveAdministration(){
this.LoadAllTheLeaveRequests();
  }

  ChangeExpand(sr:NewLeaveInfo){
    sr.IsExpand = !sr.IsExpand
   
  }


  LoadLeaveInfo(leave:NewLeaveInfo){

    const createnewRSHDialog = this._dialog.open(UpdateLeaveStatusComponent, {
      panelClass: 'removeModalOverflow',
      data: {
          title:"Update Leave Request",
          IsEdit:true,
          LeaveInfo:leave
      }, 
      minWidth: 500,
      disableClose: true,
  });

  createnewRSHDialog.afterClosed().subscribe(createnewRSH => {
    this.LoadAllTheLeaveRequests();
  });
  }

}